/* eslint-disable react/destructuring-assignment */

import idIcon from 'features/Onboarding/images/verificationId.svg';
import poaIcon from 'features/Onboarding/images/verificationPoa.svg';
import { OnboardingPage } from 'features/Onboarding/legacy/types';

import { STEPS_FOR_PRIMARY_APPLICANTS } from './allVerificationSteps';
import getBeneficiariesStep from './getBeneficiariesStep';
import locales from './locales';
import {
  GetVerificationStepsFn,
  StepConversionFn,
  VerificationStep,
  VerificationStepType,
} from './types';

const STEP_CONVERTERS: Record<VerificationStepType, StepConversionFn> = {
  address: ({ kycAddressStatus }) =>
    kycAddressStatus === 'not-shown'
      ? null
      : {
          icon: poaIcon,
          label:
            kycAddressStatus === 'waiting'
              ? locales.proofOfAddress
              : locales.proofOfAddressSent,
          markedAsCurrentForPages: [
            'verification-address-status',
            'verification-address-check-document',
            'verification-address-other',
            'verification-address-proof-type',
            'verification-address-update',
            'verification-address-upload',
          ],
          nextPage: 'verification-address-status',
          notes:
            kycAddressStatus === 'error'
              ? locales.refusedAddressNote
              : undefined,
          sidePanelLabel: locales.proofOfAddressSent,
          status: kycAddressStatus,
        },
  'capital-deposit': ({ capitalDepositStatus }) =>
    capitalDepositStatus === 'not-shown'
      ? null
      : {
          label:
            capitalDepositStatus === 'waiting'
              ? locales.companyInfo
              : locales.companyInfoSent,
          markedAsCurrentForPages: [
            'capital-deposit-questions' as OnboardingPage,
          ],
          nextPage: 'capital-deposit-questions' as OnboardingPage,
          sidePanelLabel: locales.companyInfoSent,
          status: capitalDepositStatus,
        },
  id: ({ kycIdStatus }) => ({
    icon: idIcon,
    label:
      kycIdStatus === 'waiting' ? locales.proofOfId : locales.proofOfIdSent,
    markedAsCurrentForPages: [
      'verification-id-info',
      'verification-id-document',
    ],
    nextPage: 'verification-id-info',
    notes: kycIdStatus === 'error' ? locales.refusedIdNote : undefined,
    sidePanelLabel: locales.proofOfIdSent,
    status: kycIdStatus,
  }),
  'shine-start': ({ shineStartStatus }) =>
    shineStartStatus === 'not-shown'
      ? null
      : {
          label: locales.shineStartStepTitle,
          markedAsCurrentForPages: ['verification' as OnboardingPage],
          nextPage: 'verification' as OnboardingPage,
          notes: locales.shineStartStepDescription,
          status: shineStartStatus,
        },
  'supporting-docs-beneficiaries': (status) =>
    status.multiKycStatus === 'not-shown' ? null : getBeneficiariesStep(status),
};

const filterNullValues = (steps: (VerificationStep | null)[]) =>
  steps.filter((value) => value !== null) as VerificationStep[];

const getVerificationSteps: GetVerificationStepsFn = (
  status,
  orderedStepTypes,
) => {
  const stepValidationList = STEPS_FOR_PRIMARY_APPLICANTS;
  const orderedStepsValidForApplicantType = orderedStepTypes.filter(
    (stepType) => stepValidationList.includes(stepType),
  );
  return filterNullValues(
    orderedStepsValidForApplicantType.map((stepType) =>
      STEP_CONVERTERS[stepType](status),
    ),
  );
};

export default getVerificationSteps;
